import * as React from "react";

export const useEffectWhenMounted = (effect: () => void, elementsToWatchOutFor: any[]) => {
    const [alreadyTriggeredOnce, setAlreadyTriggeredOnce] = React.useState(false);

    React.useEffect(() => {
        if (alreadyTriggeredOnce) {
            effect();
        } else {
            setAlreadyTriggeredOnce(true);
        }
    }, elementsToWatchOutFor)
}


// WEBPACK FOOTER //
// ./src/hooks/useEffectWhenMounted.hook.ts